module.exports = __webpack_public_path__ + "img/MTCISPSC.cd4506ea.svg";